import styled from 'styled-components';

// ===== VERSÃO DESKTOP (ORIGINAL - INTACTA) =====
export const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0a1428 0%, #1e3a5f 100%);
  color: #ffffff;
`;

export const TopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 3rem;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  
  img {
    height: 40px;
    width: auto;
    
    @media (max-width: 768px) {
      height: 32px;
    }
  }
  
  h1 {
    margin: 0;
    font-size: 1.5rem;
    font-weight: bold;
    color: #4A9EFF;
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
  
  p {
    margin: 0;
    font-size: 0.9rem;
    color: #B8C5D1;
    
    @media (max-width: 768px) {
      font-size: 0.8rem;
    }
  }
`;

export const NavButtons = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    gap: 0.5rem;
  }
`;

export const NavButton = styled.button`
  background: ${props => props.active ? 'rgba(74, 158, 255, 0.2)' : 'rgba(255, 255, 255, 0.05)'};
  border: 1px solid ${props => props.active ? '#4A9EFF' : 'rgba(74, 158, 255, 0.3)'};
  color: ${props => props.active ? '#4A9EFF' : '#B8C5D1'};
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
  
  &:hover {
    background: rgba(74, 158, 255, 0.2);
    color: #4A9EFF;
    border-color: #4A9EFF;
  }
`;

export const NavButton2 = styled.button`
  background: transparent;
  border: none;
  color: ${props => props.active ? '#4A9EFF' : '#B8C5D1'};
  padding: 0.75rem 1.5rem;
  cursor: normal;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  
  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
`;

export const MainContainer = styled.div`
  padding: 2rem 3rem;
  
  @media (max-width: 768px) {
    padding: 0.75rem;
  }
`;

export const CardsSection = styled.div`
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    margin-bottom: 1rem;
  }
`;

export const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  
  @media (max-width: 1200px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.75rem;
  }
`;

export const LegalCard = styled.div`
  background: rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 2rem;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(74, 158, 255, 0.2);
  text-align: center;
  height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media (max-width: 768px) {
    padding: 1rem;
    height: 120px;
    border-radius: 8px;
  }
  
  &:hover {
    transform: translateY(-5px);
    background: rgba(74, 158, 255, 0.1);
    border-color: #4A9EFF;
    box-shadow: 0 10px 30px rgba(74, 158, 255, 0.2);
    
    @media (max-width: 768px) {
      transform: translateY(-2px);
      box-shadow: 0 5px 15px rgba(74, 158, 255, 0.2);
    }
  }
`;

export const CardIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
`;

export const CardTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #4A9EFF;
  margin-bottom: 0.5rem;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 0.25rem;
  }
`;

export const CardDescription = styled.p`
  color: #B8C5D1;
  font-size: 0.85rem;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  
  @media (max-width: 768px) {
    font-size: 0.7rem;
    line-height: 1.3;
    -webkit-line-clamp: 2;
  }
`;

// ===== DESKTOP SIDEBAR (ORIGINAL) =====
export const DesktopLayout = styled.div`
  display: flex;
  gap: 2rem;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Sidebar = styled.div`
  text-align: left;
  width: 300px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 1.5rem;
  height: fit-content;
  border: 1px solid rgba(74, 158, 255, 0.1);
`;

export const SidebarSection = styled.div`
  margin-bottom: 2rem;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const SidebarTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: #4A9EFF;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
`;

export const SidebarItem = styled.div`
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  color: #B8C5D1;
  
  &:hover {
    background: rgba(74, 158, 255, 0.1);
    transform: translateX(5px);
  }
`;

export const ContentArea = styled.div`
  flex: 1;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 2rem;
  border: 1px solid rgba(74, 158, 255, 0.1);
`;

// ===== MOBILE LAYOUT (OTIMIZADO) =====
export const MobileLayout = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    margin-top: 1rem;
  }
`;

export const MobileMenuButton = styled.button`
  display: none;
  
  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(74, 158, 255, 0.2);
    border: 1px solid #4A9EFF;
    color: #4A9EFF;
    padding: 0.75rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.85rem;
    font-weight: 500;
    margin-bottom: 1rem;
    width: 100%;
    justify-content: center;
    transition: all 0.3s ease;
    
    &:hover {
      background: rgba(74, 158, 255, 0.3);
    }
  }
`;

export const MobileMenuOverlay = styled.div`
  @media (max-width: 768px) {
    opacity: ${props => props.isOpen ? 1 : 0};
    pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 1000;
    backdrop-filter: blur(5px);
    transition: opacity 01s ease;
  }
`;

export const MobileSidebar = styled.div`
  @media (max-width: 768px) {
    opacity: ${props => props.isOpen ? 1 : 0};
    pointer-events: ${props => props.isOpen ? 'auto' : 'none'};
    position: fixed;
    top: 0;
    left: 0;
    width: 85vw;
    max-width: 300px;
    height: 100vh;
    background: linear-gradient(135deg, #0a1428 0%, #1e3a5f 100%);
    z-index: 1001;
    overflow-y: auto;
    padding: 0.75rem;
    transform: translateX(${props => props.isOpen ? '0' : '-100%'});
    transition: opacity 1s ease, transform 1s ease;
    border-right: 1px solid rgba(74, 158, 255, 0.2);
    text-align: left;

    /* Custom scrollbar styles for mobile sidebar */
    &::-webkit-scrollbar {
      width: 6px;
      background: rgba(74, 158, 255, 0.08);
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(74, 158, 255, 0.3);
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #4A9EFF;
    }
  }

  /* Estilos específicos para mobile dentro do sidebar */
  ${SidebarSection} {
    @media (max-width: 768px) {
      margin-bottom: 1.5rem;
    }
  }
  ${SidebarTitle} {
    @media (max-width: 768px) {
      font-size: 0.9rem;
      margin-bottom: 0.75rem;
      padding-bottom: 0.4rem;
    }
  }
  ${SidebarItem} {
    @media (max-width: 768px) {
      padding: 0.6rem;
      margin-bottom: 0.4rem;
      font-size: 0.8rem;
      line-height: 1.3;
      border-radius: 6px;
      &:hover {
        transform: translateX(3px);
      }
    }
  }
`;

export const MobileMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-left: 1rem;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(74, 158, 255, 0.2);
  margin-bottom: 0.75rem;
`;

export const MobileMenuTitle = styled.h3`
  color: #4A9EFF;
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
`;

export const MobileCloseButton = styled.button`
  background: none;
  border: none;
  color: #4A9EFF;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
  transition: background 0.3s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover {
    background: rgba(74, 158, 255, 0.1);
  }
`;

export const MobileContentArea = styled.div`
  display: none;
  
  @media (max-width: 768px) {
    display: block;
    background: rgba(255, 255, 255, 0.05);
    border-radius: 8px;
    padding: 0.75rem;
    border: 1px solid rgba(74, 158, 255, 0.1);
    
    /* Otimização de texto para mobile */
    h1, h2, h3 {
      font-size: 1.1rem !important;
      line-height: 1.3 !important;
      margin-bottom: 0.75rem !important;
    }
    
    h4, h5, h6 {
      font-size: 1rem !important;
      line-height: 1.3 !important;
      margin-bottom: 0.5rem !important;
    }
    
    p {
      font-size: 0.85rem !important;
      line-height: 1.4 !important;
      margin-bottom: 0.75rem !important;
    }
    
    li {
      font-size: 0.8rem !important;
      line-height: 1.4 !important;
      margin-bottom: 0.4rem !important;
    }
    
    /* Espaçamento entre seções */
    > div {
      margin-bottom: 1rem;
    }
    
    /* Botões e links */
    button, a {
      font-size: 0.8rem !important;
      padding: 0.5rem 0.75rem !important;
    }
    
    /* Tabelas responsivas */
    table {
      font-size: 0.75rem !important;
      
      th, td {
        padding: 0.4rem !important;
      }
    }
    
    /* Imagens responsivas */
    img {
      max-width: 100% !important;
      height: auto !important;
    }
  }
`;

export const ContentPanel = styled.div`
  h2 {
    color: #4A9EFF;
    margin-bottom: 1rem;
    font-size: 1.5rem;
    
    @media (max-width: 768px) {
      font-size: 1.1rem;
      margin-bottom: 0.75rem;
    }
  }
  
  p {
    color: #E1E8ED;
    line-height: 1.6;
    
    @media (max-width: 768px) {
      font-size: 0.85rem;
      line-height: 1.4;
    }
  }
  
  /* Otimizações gerais para mobile */
  @media (max-width: 768px) {
    h1, h2, h3, h4, h5, h6 {
      line-height: 1.3;
    }
    
    ul, ol {
      padding-left: 1.2rem;
    }
    
    li {
      margin-bottom: 0.4rem;
    }
  }
`;